module.exports = __webpack_public_path__ + "static/media/example04-01.af8d04a9.svg";